import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class StudentCodeService extends ServiceGlobal {
    api_find_one: any = 'next_student_code';
}



// WEBPACK FOOTER //
// ./src/app/common/services/student-code.service.ts